import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { DELETE_FOLLOW_UP, EDIT_FOLLOW_UP, ADD_FOLLOW_UP_ASSIGNEES, DELETE_FOLLOW_UP_ASSIGNEES, UPDATE_FOLLOWUP_ASSIGNEE_OWNER } from "@Broker/@Modules/clients/board/store/board-actions";
import AssigneeSelect from "../shared/assignee-select";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { showToast } from "@Shared/utils/constants";
import TimeInput from "../../../../../../modules/automation/automation/components/argument-types/time";
import TimelineItemCard from "./utils/timeline-card.vue";
import TimelineCardFooter from "./utils/timeline-card-footer.vue";
import Err from "@Broker/@Routes/error";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS } from "../../../store/board-getters";
import { debounce, isEmpty } from "lodash";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import HtmlIframePreview from "@Shared/components/general/html-iframe-preview.vue";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineFollowUp",
  components: {
    AssigneeSelect,
    InlinePrompt,
    TimeInput,
    TimelineItemCard,
    TimelineCardFooter,
    DatepickerInput,
    MaterialInput,
    ProfileAvatar,
    HtmlIframePreview
  },
  mixins: [HTMLTextEvaluationMixin],
  props: {
    creator: {
      type: Object,
      default: () => ({})
    },
    scheduledDate: {
      type: [String, Date],
      required: true
    },
    scheduledTime: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    pinned: {
      type: Boolean,
      default: false
    },
    complete: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ""
    },
    activityType: {
      type: String,
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      default: ""
    },
    assignees: {
      type: Array,
      default: () => []
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    latestUpdate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editing: false,
      height: "auto",
      isComplete: this.complete,
      followUpDescription: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.description),
      followUpScheduledDate: this.scheduledDate,
      followUpScheduledTime: this.scheduledTime,
      labelValue: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", ["getProfileOwner", CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS])), mapFields("AccountStore", ["accountPreferences.followUpNotificationTime"])), {}, {
    showCardFaded() {
      return this.isComplete && !this.editing;
    },
    canSave() {
      return this.htmlToTextContent(this.followUpDescription) !== "";
    },
    owner() {
      return this.getProfileOwner(this.clientProfileId);
    },
    descriptionText: {
      get() {
        return this.followUpDescription.replace("<div>", "").replace("</div>", "");
      },
      set(value) {
        this.followUpDescription = this.upperCaseFirst(value);
      }
    },
    descriptionTextHTML() {
      return RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.descriptionText);
    },
    formattedScheduledTime() {
      return moment(this.followUpScheduledTime, "'HH:mm'").format("LT");
    },
    scheduledCssClass() {
      if (this.complete) return "text-gray";
      return this.$options.filters.parseReminderClassificationClass(this.scheduledDate, this.scheduledTime);
    },
    customFieldsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_TAGS(this.clientProfileId);
    },
    customFieldsHintsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS(this.clientProfileId);
    },
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    }
  }),
  watch: {
    owner(newOwner, oldOwner) {
      if (isEmpty(oldOwner) || !(oldOwner != null && oldOwner.username)) return;
      if (newOwner.username !== oldOwner.username) {
        this.UPDATE_FOLLOWUP_ASSIGNEE_OWNER({
          id: this.clientProfileId,
          followUpId: this.id,
          oldOwner: oldOwner.username,
          newOwner: newOwner.username
        });
      }
    },
    description(val) {
      this.followUpDescription = RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.upperCaseFirst(val));
    },
    complete(val) {
      this.isComplete = val;
    },
    editing(val) {
      this.$nextTick(() => {
        if (val) {
          this.$refs.notifySelect.setEdit({
            edit: true,
            open: false
          });
          this.init();
        }
      });
    },
    customFieldsTags: {
      deep: true,
      handler(value) {
        var _this$editor;
        (_this$editor = this.editor) == null ? void 0 : _this$editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        var _this$editor2;
        (_this$editor2 = this.editor) == null ? void 0 : _this$editor2.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      var _context;
      this.height = _findInstanceProperty(_context = $(this.$el)).call(_context, ".follow-up-description").outerHeight(true);
    });
  },
  updated() {
    this.$nextTick(() => {
      var _context2;
      this.height = _findInstanceProperty(_context2 = $(this.$el)).call(_context2, ".follow-up-description").outerHeight(true);
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [EDIT_FOLLOW_UP, DELETE_FOLLOW_UP, ADD_FOLLOW_UP_ASSIGNEES, DELETE_FOLLOW_UP_ASSIGNEES, UPDATE_FOLLOWUP_ASSIGNEE_OWNER])), {}, {
    upperCaseFirst(text) {
      return this.$options.filters.upperCaseFirst(text);
    },
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    },
    handleInput({
      target: note
    }) {
      note.style.height = "auto";
      note.style.height = note.scrollHeight + "px";
    },
    editScheduledDate() {
      this.editing = true;
    },
    editFollowUp() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    },
    completeFollowUp: debounce(function () {
      this.isComplete = !this.isComplete;
      this.saveFollowUp();
      showToast("success", "activityUpdated");
    }, 200),
    saveFollowUp() {
      if (this.editor) {
        this.followUpDescription = this.editor.getHTML();
      } else {
        this.followUpDescription = RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia(this.followUpDescription);
      }
      this.EDIT_FOLLOW_UP({
        id: this.clientProfileId,
        followUpId: this.id,
        data: {
          description: this.followUpDescription,
          scheduledDate: this.followUpScheduledDate,
          scheduledTime: this.followUpScheduledTime,
          complete: this.isComplete,
          updatedAt: moment().utc().format()
        }
      });
    },
    handleSubmit() {
      this.editing = false;
      this.saveFollowUp();
    },
    async handleDelete() {
      try {
        await this.DELETE_FOLLOW_UP({
          id: this.clientProfileId,
          followUpId: this.id
        });
        showToast("success", "activityDeleted");
      } catch (error) {
        Err.handle(error);
      }
    },
    async handleAssigneeChange(data, type) {
      var _context4;
      const assigneeData = [];
      if (Array.isArray(data)) {
        data.forEach(assignee => {
          var _context3;
          if (!_includesInstanceProperty(_context3 = this.assignees).call(_context3, assignee.username)) {
            assigneeData.push(assignee);
          }
        });
      }
      switch (type) {
        case "select":
          try {
            await this.ADD_FOLLOW_UP_ASSIGNEES({
              id: this.clientProfileId,
              followUpId: this.id,
              assignees: [assigneeData[0].username]
            });
          } catch (error) {
            Err.handle(error);
          }
          break;
        case "unselect":
          if (_includesInstanceProperty(_context4 = this.assignees).call(_context4, data.username)) {
            try {
              await this.DELETE_FOLLOW_UP_ASSIGNEES({
                id: this.clientProfileId,
                followUpId: this.id,
                assignee: data.username
              });
            } catch (error) {
              Err.handle(error);
            }
          }
          break;
      }
    },
    init() {
      const target = $(this.$refs.textarea);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        blockPastedImages: false,
        sanitizeContent: RichTextEditor.sanitizeRichTextWithoutEmbeddedMedia,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      $(".note-codable").attr("id", "edit-text-id");
      $("#backColorPicker").attr("id", "background-color");
      $("#foreColorPicker").attr("id", "foreground-color");
    },
    handleEditorChange(_, content) {
      this.descriptionText = content;
    }
  })
});